import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { createAppRouter } from './router/index.js'
import { createAppI18n } from './i18n.js'
import './style.css'

const app = createApp(App)
app.use(createPinia())
app.use(createAppRouter())
app.use(createAppI18n())
app.mount('#app')

// A service worker registered in dev serves stale assets and is genuinely painful to
// clear, so registration only ever happens in a production build.
if (import.meta.env.PROD) {
  const { registerSW } = await import('virtual:pwa-register')
  registerSW({ immediate: true })
}
